import react from "react";
import { Navigate, Outlet } from "react-router-dom";
const PrivateComponent = () => {
    const localData = localStorage.getItem('token')
    return localData ? <Outlet /> : <Navigate to="/landing" />
}
export default PrivateComponent